import React from 'react'
import { NavLink } from 'react-router-dom'

const Footer = () => {
  return (
    <>
      <div className="page text-[100px] rotate-90 hidden md:flex botom">
        Hello There
      </div>
    </>
  )
}

export default Footer